import ITranslateService = angular.translate.ITranslateService;
import {IComponentOptions, IFormController} from 'angular';
import TSPasswordData from '../../../models/TSPasswordData';
import './dv-password-changer.scss';

export class DVPasswordChangerComponentConfig implements IComponentOptions {
    transclude = false;
    bindings: any = {
        passworddata: '<',
        emailEnabled: '=',
        emailVisible: '='
    };
    template = require('./dv-password-changer.html');
    controller = DVPasswordChangerController;
    controllerAs = 'vm';

    require: any = {parentForm: '?^form'};
}

export class DVPasswordChangerController {
    static $inject = ['$translate'];

    emailEnabled: boolean;
    emailVisible: boolean;
    required: boolean = true;
    passworddata: TSPasswordData;
    $translate: ITranslateService;
    parentForm: IFormController;

    /* @ngInject */
    constructor($translate: ITranslateService) {
        this.$translate = $translate;

    }

    $onInit() {
    }

    public getModel(): TSPasswordData {
        return this.passworddata;
    }

    public isEmaildisabled(): boolean {
        return this.emailEnabled === undefined && this.emailEnabled !== true;
    }

    public isEmailVisible(): boolean {
        return this.emailVisible === undefined || this.emailVisible === true;
    }

}




// WEBPACK FOOTER //
// ./src/app/core/component/dv-password-changer/dv-password-changer.ts